// extracted by mini-css-extract-plugin
export default {"items":"Projects_items__0fKxS","fade-in":"Projects_fade-in__r7coY"};